import { PageBuilder } from '@chipinside/pagebuilder'
import { Translate } from '@chipinside/translate'
import { Box, Button } from '@mui/material'
import { Link } from 'react-router-dom'

import { Drawer } from '#/components/Drawer'
import { CEnv } from '#/components/Maps/Markers/types'
import { useFarmSlug } from '#/store/ducks/farm'
import { usePermissions } from '#/store/ducks/permissions'
import { useFormBuilder } from '#/store/hooks/useFormBuilder'
import { endpoint } from '#/store/services/endpoints'
import { getLink } from '#/utils/getLink'
import { listeners } from '#/utils/listeners'

export default function CEnvContent({ marker }: { marker: CEnv }) {
  const farmSlug = useFarmSlug()

  const controller = endpoint.farm.cow_comfort.point.drawer({ farm: farmSlug, point: marker.id })

  return <PageBuilder controller={controller} />
}

export function CEnvFooter({ marker }) {
  const { build } = useFormBuilder()
  const permissions = usePermissions()
  const farmSlug = useFarmSlug()

  function updateMarker(marker) {
    Drawer.close()
    build({
      afterSuccess: () => window.dispatchEvent(new Event(listeners.cenvmap)),
      formName: 'monitoring_point',
      formType: 'update',
      params: { farm: farmSlug, point: marker?.id },
    })
  }

  if (!permissions.farm.view_temperature_history && !permissions.farm.update_device_point) return

  const historyLink = getLink({
    id: 'farm-thermal-stress-hourly',
    params: { farm: marker.farm_slug, point: marker.id },
  })

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {historyLink && (
        <Button
          variant="outlined"
          fullWidth
          component={Link}
          to={historyLink}
          onClick={() => Drawer.close()}
        >
          {Translate({ messageKey: 'view_history' })}
        </Button>
      )}
      {permissions.farm.update_device_point && (
        <Button variant="outlined" fullWidth onClick={() => updateMarker(marker)}>
          {Translate({ messageKey: 'update_item' })}
        </Button>
      )}
    </Box>
  )
}
